import { i } from "react-router/dist/development/fog-of-war-Cm1iXIp7";
import ComponentCard from "../../../components/common/ComponentCard";
import PageMeta from "../../../components/common/PageMeta";
import Button from "../../../components/ui/button/Button";
import { useNavigate } from "react-router-dom";
import RemedialActionsTable from "./RemedialActionsTable";

const RemedialActions = () => {
	const navigate = useNavigate();
	return(
		<>
			 <PageMeta 
        title="Compliance Inspections - Remedial Actions | Hospitality Genie"
        description="Compliance Inspections - Remedial Actions"
      />
      <div className="space-y-6">
      <ComponentCard title="Compliance Inspections - Remedial Actions">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">Remedial Actions</div>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
                className="inline-flex items-center gap-2 px-4 py-3 text-sm font-medium text-[#ffffed] rounded-lg bg-[#142900] hover:bg-[#e1ffb4] hover:text-[#142900]"
              >
                Filter Options
              </button>
            </div>
        </div>
        
        <div>
          {/* Table Component */}
          <RemedialActionsTable />
        </div>
      </ComponentCard>
      </div>

		</>		

	)
}

export default RemedialActions;